import { createContext, useContext } from 'react';

export const IsTouchContext = createContext<boolean | null>(null);

export const useIsTouchDevice = () => {
  const value = useContext(IsTouchContext);

  if (value === null) throw new Error('IsTouchProvider not found, please, add it to the tree');

  return value;
};
